import React, { useState } from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import CustomeNotificationImage from '../../../components/Insights/CustomeNotificationImage';

import RecommendedNotifications from './RecommendedNotifications';



const SmartNotifications = () => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);       // ✅ Define it
    const handleClose = () => setOpen(false);     // Optional close handler

    const [openCustomeNotificationImage, setOpenCustomeNotificationImage] = useState(false);


    const notifications = [
        {
            icon: './assets/images/app-activity/insights/smart-notifications/activity-icon.svg',
            bgColor: '#27AE6014',
            title: 'Suspiciously high activity',
            description: 'Daily activity levels consistently surpass 90%.',
        },
        {
            icon: './assets/images/app-activity/insights/smart-notifications/members-overworking-icon.svg',
            bgColor: '#FF832814',
            title: 'Members overworking',
            description: 'Employees work an average of more than 9.5 hours each day.',
        },
        {
            icon: './assets/images/app-activity/insights/smart-notifications/members-underworking-icon.svg',
            bgColor: '#6A00FF14',
            title: 'Members underworking',
            description: 'Daily work hours are typically less than 5.',
        },
        {
            icon: './assets/images/app-activity/insights/smart-notifications/low-activity-level-icon.svg',
            bgColor: '#F4413D14',
            title: 'Members with low activity level',
            description: 'Weekly activity levels are generally below 35%.',
        },

        {
            icon: './assets/images/app-activity/insights/smart-notifications/low-core-work-icon.svg',
            bgColor: '#E1B40014',
            title: 'Members with low core work',
            description: 'Core work hours average under 25% each week.',
        },
        {
            icon: './assets/images/app-activity/insights/smart-notifications/work-time-icon.svg',
            bgColor: '#0076FE14',
            title: 'Members with unproductive work time',
            description: 'Unproductive work time exceeds 10% of total work hours daily.',
        },
        {
            icon: './assets/images/app-activity/insights/smart-notifications/media-websites-icon.svg',
            bgColor: '#CC33FF14',
            title: 'Members using social media websites',
            description: 'Team members spend more than 30 minutes daily on social media.',
        },
        {
            icon: './assets/images/app-activity/insights/smart-notifications/required-applications-icon.svg',
            bgColor: '#FFB82A14',
            title: 'Members not using required applications',
            description: 'Team members use required applications for less than 30 minutes weekly.',
        },

        {
            icon: './assets/images/app-activity/insights/smart-notifications/ai-websites-icon.svg',
            bgColor: '#9C2CF314',
            title: 'Members using Al websites',
            description: 'Team members spend over 30 minutes each day on AI chatbot platforms.',
        },
        {
            icon: './assets/images/app-activity/insights/smart-notifications/entertainment-icon.svg',
            bgColor: '#FF4D1214',
            title: 'Members using entertainment websites',
            description: 'Team members dedicate more than 30 minutes daily to entertainment sites.',
        },
        // Duplicates can be added here if necessary
    ];


    return (
        <div>
           
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, marginBottom: '20px', }}>
                <Typography component="a" href="/highlights" className="fw-semibold mb-0" sx={{ fontSize: '16px', color: '#1A1F36', display: 'flex', alignItems: 'center', lineHeight: '1', gap: '6px', fontFamily: 'Manrope' }}>
                    <span><KeyboardArrowLeftIcon sx={{ fontSize: '16px', color: '#1760EC', fontFamily: 'Manrope' }} /></span>
                    Insights</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, marginBottom: '20px', }}>
                <Typography className="fw-semibold mb-0" sx={{ fontSize: '24px', color: '#1A1F36', fontFamily: 'Manrope' }}>Smart Notifications</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 1 }}>

                    <Button onClick={() => setOpenCustomeNotificationImage(true)} sx={{ fontFamily: 'Manrope', background: '#0076FE', borderRadius: '100px', color: '#FFFFFF', fontSize: '16px', textTransform: 'capitalize', height: '38px', border: '1px solid #E5E8EB', padding: '8px 18px' }}>
                        <FilterListIcon sx={{ fontSize: '18px', marginRight: '10px', fontFamily: 'Manrope' }} /> Custom Notification
                    </Button>

                </Box>
            </Box>
            <Box sx={{ margin: '0 auto 32px' }}>
                <Typography sx={{ fontSize: '17px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 8px', fontFamily: 'Manrope' }}>Recommended notifications</Typography>
                <Grid container spacing={2}>
                    {notifications.map((item, index) => (
                        <Grid size={{ xl: 3, lg: 4, md: 4, sm: 6, xs: 12 }}>
                            <Box sx={{ backgroundColor: '#fff', border: '1px solid #DFDFDF', borderRadius: '8px', fontFamily: 'Manrope' , height: '280px' }}>
                                <RecommendedNotifications key={index} {...item} />
                            </Box>
                        </Grid>
                    ))}

                </Grid>


            </Box>

            <div style={{ padding: '40px', textAlign: 'center', backgroundColor: '#fff', border: '1px solid #DFDFDF', borderRadius: '8px' }}>
                <img src='./assets/images/app-activity/insights/notification-img.png' className='img-fluid' alt='notification img' />
                <Typography sx={{ fontSize: '22px', color: '#1A1F36', fontWeight: '600', margin: '48px auto 12px', fontFamily: 'Manrope' }}>No Notifications Yet</Typography>
                <Typography sx={{    fontSize: {xl: '16px' , lg: '16px', md: '14px' , sm: '14px' , xs: '14px'}, color: '#373737', fontWeight: '400', fontFamily: 'Manrope' }}>Create your first notification or choose a template above to get started.</Typography>
                <button onClick={() => setOpenCustomeNotificationImage(true)} style={{ fontSize: '16px', fontWeight: '600', color: '#FFFFFF', backgroundColor: '#0076FE', height: '40px', padding: '10px 24px', borderRadius: '100px', lineHeight: '1', margin: '48px auto 0', fontFamily: 'Manrope' }}>Create Notification</button>
            </div>
            <CustomeNotificationImage
                open={openCustomeNotificationImage}
                onClose={() => setOpenCustomeNotificationImage(false)}
            />

        </div >
    )
}

export default SmartNotifications
